module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "fans_item",
    attrs: {
      "href": _vm.linkUrl || 'javascript:;'
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrcLink,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fans_name"
  }, [_vm._v(_vm._s(_vm.userName))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29606886"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fansitem.vue
// module id = 215
// module chunks = 3